
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Measle(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Measle"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Measles is <b>an acute viral respiratory illness.</b> It is
                                    characterized by a prodrome of fever (as high as 105°F) and
                                    malaise, cough, coryza, and conjunctivitis -the three “C”s -, a
                                    pathognomonic enanthema (Koplik spots) followed by a
                                    maculopapular rash. The rash usually appears about 14 days
                                    after a person is exposed.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Measle/1.png")} alt="Measle" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <ul className="listUnstyle">
                                    <li>
                                        <p>
                                            <b>Pain areas:</b>
                                            <br />
                                            in the muscles
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Whole body:</b>
                                            <br />
                                            fever, malaise, fatigue, or loss of appetite
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Nasal:</b>
                                            <br />
                                            runny nose or sneezing
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Also common: </b>
                                            <br />
                                            skin rash, conjunctivitis, dry cough, diarrhoea, headache, koplik's spots, sensitivity to
                                            light, sore throat, or swollen lymph nodes
                                        </p>
                                    </li>
                                </ul>
                                <a className="links" href="https://en.wikipedia.org/wiki/Measles">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Measle;